<!-- 投手操作日志 -->
<template>
<div>
	<!-- 标题 -->
	<div class="page-title">投手操作日志</div>
	
	<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 10px 0 0;">
		<div class="screen-box">
			<div class="screen-label">操作日期</div>
			<a-range-picker style="width:280px;" @change="onChangeDate" :allowClear="false" 
			:locale="locale" 
			:value="[this.moment(startTime, dateFormat),this.moment(endTime, dateFormat)]" />
		</div>
		
		<div class="screen-box">
			<div class="screen-label">操作类型</div>
			<a-select
				show-search
				allowClear
			    style="width: 280px"
			    placeholder="请选择操作类型"
			    @change="handleChangeB"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
			  >
			    <a-select-option v-for="(value,key) in operationType" :key="key" :value="key" :title="value">
			      {{value}}
			    </a-select-option>
			</a-select>
			
		</div>
		
		<div class="screen-box">
			<div class="screen-label">投手</div>
			<a-select
				show-search
				allowClear
			    style="min-width: 200px"
			    placeholder="请选择投手"
			    @change="handleChangeA"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
			  >
			    <a-select-option v-for="(value,key) in filterList" :key="key" :value="key">
			      {{value}}
			    </a-select-option>
			</a-select>
			
		</div>
		
		<div class="screen-box">
			<div class="screen-label">操作项目ID</div>
			<a-input v-model="r_put_id" allowClear placeholder="请输入" style="width: 200px;"/>
		</div>
		
		<a-button class="screen-box" :loading="search_button_loading" @click="searchButton('button')" icon="search" type="primary">搜索</a-button>
	</div>
	
	<div>
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			<div  v-for="(item,index) in rableTitle" :key="index" >
				<div class="table-th-cell" 
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<!-- ID -->
			<div class="table-td-cell" :style="{'width':rableTitle[0].width + 'px'}">
				{{item.id}}
			</div>
			<!-- 操作人ID -->
			<div  class="table-td-cell" :style="{'width':rableTitle[1].width + 'px'}">
				{{item.op_id}}
			</div>
			<!-- 操作人 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[2].width + 'px'}">
				{{item.user_name}}
			</div>
			<!-- 操作时间 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[3].width + 'px'}">
				{{item.updated_at}}
			</div>
			<!-- 操作类型 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[4].width + 'px'}">
				{{item.type_text}}
			</div>
			<!-- 操作项目ID -->
			<div  class="table-td-cell" :style="{'width':rableTitle[5].width + 'px'}">
				{{item.put_id}}
			</div>
			<!-- 修改前值 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[6].width + 'px'}">
				{{item.old_put_money}}
			</div>
			<!-- 修改后值 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[7].width + 'px'}">
				{{item.put_money}}
			</div>
			
		</div>
		
		
		<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_scroll_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
	</div>
	
	<!-- 分页 -->
	<!-- <div :style="{'width': table_scroll_width + 'px',}" style="text-align: center;margin-top: 30px;">
		<a-pagination v-model="r_page" :pageSize="r_limit" :total="table_total" @change="paginationChange" />
	</div> -->
	<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="table_null_width"
	:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
	@pagination-Change="paginationChange" @change-size-limit="changeSizeLimit"></pagingCompont>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';

import { pitcherLogList, pitcherLogType, logSelectUser } from '@/request/api'	
export default {
	name: 'pitcherLog_',
	components: {
		
	},
	data() {
		this.dateFormat = 'YYYY-MM-DD'
		return {
			locale,
			moment,
			startTime: '2022-06-12',
			endTime: '2022-06-23',
			
			r_op_id:"", // 操作人id
			filterList: {},
			
			// 表格部分内容
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID", width:90, type:"id", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"操作人ID", width:100, type:"op_id", },
				{title:"操作人", width:120, type:"user_name", },
				{title:"操作日期", width:180, type:"updated_at", },
				{title:"操作类型", width:250, type:"type", },
				{title:"操作项目ID", width:150, type:"put_id", },
				{title:"修改前值", width:130, type:"old_put_money", },
				{title:"修改后值", width:130, type:"put_money", },
				
			],
			tableShowData: [],
			table_scroll_width: 1000,
			table_null_width: 1000,
			search_button_loading: false,
			
			r_page: 1, // 页数
			r_limit: 20, // 每页多少条
			table_total: 0, // 表格内容总数
			
			operationType: {}, // 操作类型
			
			r_type: "", // 历史操作数据下拉类型
			r_put_id: null, // 操作项目ID
		}
	},
	mounted() {
		let that = this
		that.search_button_loading = true
		// 获取14天前日期
		that.startTime = this.$getBeforeDay(14)
		
		// 获取当前日期
		that.endTime = this.$getThisDay()
		
		// let nn = 0
		// that.rableTitle.forEach((res,index)=>{
		// 	nn = nn + res.width
		// })
		// that.table_scroll_width = nn + 30
		// 获取表格信息
		let table_info = this.$getTableInfo(that.rableTitle)
		// that.body_width = table_info.body_width
		that.table_scroll_width = table_info.table_width
		that.table_null_width = table_info.null_width
		
		// 历史操作数据下拉类型
		pitcherLogType().then(res=>{
			console.log("历史操作数据下拉类型",res);
			that.operationType = res.data.data.list
		})
		
		// 获取搜索条件
		logSelectUser().then(res=>{
			console.log('获取搜索条件',res.data.data)
			
			that.filterList = res.data.data.list
		})
		
		that.searchButton()
	},
	methods: {
		// 日期选择
		onChangeDate(date, dateString) {
			// console.log(date, dateString);
			this.startTime = dateString[0]
			this.endTime = dateString[1]
		},
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 投手
		
		// handleChangeAA(value) {
		//       console.log(`selected ${value}`);
		//     },
		handleChangeA(value) {
			console.log(value)
			this.r_op_id = value // 记录选择的人的id
		    console.log(`selected ${value}`);
		},
		// 历史操作数据下拉类型
		handleChangeB(e){
			this.r_type = e
		},
		
		// 搜索
		searchButton(type){
			let that = this
			that.search_button_loading = true
			
			if(type == 'button'){
				that.r_page = 1
			}
			
			let r_data = {
				start_date: that.startTime.replace(/-/g, ''),
				end_date: that.endTime.replace(/-/g, ''),
				page: that.r_page,
				limit: that.r_limit,
				
				put_id: that.r_put_id,
			}
			if(that.r_type){ // 历史操作数据下拉类型
				r_data.type = that.r_type
			}
			if(that.r_op_id){ // 操作人id
				r_data.op_id = that.r_op_id
			}
			pitcherLogList(r_data).then(res=>{
				console.log("获取登录日志列表",res)
				that.search_button_loading = false
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					that.$message.success('搜索成功');
					that.table_total = res.data.data.total
					that.tableShowData = res.data.data.data
				}
				else {
					if(res.data.code == 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`其他错误：${res.data.msg}`);
					}
				}
			})
		},
		// 分页
		paginationChange(e){
			let that = this
			this.r_page = e
			that.searchButton()
		},
		changeSizeLimit(e){
			// console.log('每页多少条',e)
			this.r_limit = e
			this.searchButton('button')
		},
	},
	filters: {
		operType(e){
			console.log("过滤器",e);
			let ttt = ""
			
			if(e == 1){
				ttt = "投放金额操作"
			}
			else if(e == 2){
				ttt = "落地页回传比例"
			}
			else if(e == 3){
				ttt = "巨量回传比例"
			}
			else if(e == 4){
				ttt = "百度回传比例"
			}
			else if(e == 5){
				ttt = "公众号订单"
			}
			else if(e == 6){
				ttt = "常读订单回传"
			}
			else if(e == 7){
				ttt = "文鼎订单回传"
			}
			
			return ttt
		}
	}
}	
</script>

<style scoped>

</style>